import * as s from "@gromia/components/theme/t.module.css";
import cx from "classnames";
import * as React from "react";
import { v4 as uuid } from "uuid";

type AlertData = {
  id: string;
  until: number;
  message: string;
};

type AlertCreationData = Omit<AlertData, "id" | "until">;

type AlertContext = {
  list: AlertData[];
  push: (x: AlertCreationData) => void;
};

const AlertContext = React.createContext<AlertContext>({
  list: [],
  push: (_x: AlertCreationData) => {},
});

function Alert(props: { message: NonNullable<React.ReactNode> }) {
  return (
    <div className={cx(s.alert, s.alertPrimary, s.shadow)}>{props.message}</div>
  );
}

function unixms(): number {
  return +new Date();
}

// -- PUBLIC
export function AlertProvider(props: { children: React.ReactNode }) {
  const [list, setList] = React.useState<AlertData[]>([]);
  const defaultExpire = 1500;

  function push(x: AlertCreationData) {
    setList([...list, { id: uuid(), until: unixms() + defaultExpire, ...x }]);
  }

  function expire() {
    const tick = unixms();
    if (list.length < 1) {
      return;
    }
    setList(list.filter(a => a.until > tick));
  }

  React.useEffect(() => {
    const tid = setTimeout(expire, 150);
    return () => clearTimeout(tid);
  });

  return (
    <AlertContext.Provider value={{ list, push }}>
      {props.children}
    </AlertContext.Provider>
  );
}

export function usePushMessage() {
  return React.useContext(AlertContext).push;
}

export function Alerts(props: { left?: number }) {
  const { list } = React.useContext(AlertContext);

  return (
    <div
      style={{
        top: 95,
        left: `calc(50% + ${props.left || 0}px)`,
        transform: "translateX(-50%)",
        maxWidth: 680,
      }}
      className={cx(s.positionFixed, s.zIndex8, s.mAuto, s.w100)}
    >
      {list.map(a => <Alert key={a.id} message={a.message} />)}
    </div>
  );
}
